const SRC_DETECTION_TIMEOUT = 100;

export default class ResponsiveImage {
    constructor(context) {
        this.refs = {
            imageElement: context
        };

        this.bindVerifyImage = this.verifyImage.bind(this);
        this.bindHandleError = this.handleError.bind(this);

        this.init();
    }

    init() {
        this.refs.imageElement.addEventListener('load', this.bindVerifyImage);
        this.refs.imageElement.addEventListener('error', this.bindHandleError);

        setTimeout(() => this.verifyImage(), SRC_DETECTION_TIMEOUT);
    }

    handleError() {
        this.loadFallback();
    }

    loadFallback() {
        this.refs.imageElement.removeEventListener('load', this.bindVerifyImage);
        this.refs.imageElement.removeEventListener('error', this.bindHandleError);

        this.refs.imageElement.removeAttribute('srcset');
        this.refs.imageElement.removeAttribute('sizes');

        const imageFallbackSrc = this.refs.imageElement.getAttribute('data-image-fallback');

        this.refs.imageElement.src = imageFallbackSrc;
    }

    verifyImage() {
        const { currentSrc } = this.refs.imageElement;

        if (currentSrc) {
            const image = new Image(1, 1);

            image.addEventListener('load', e => document.body.removeChild(e.target));
            image.addEventListener('error', e => {
                this.loadFallback(this.refs.imageElement);

                document.body.removeChild(e.target);
            });

            image.style.display = 'none';
            image.src = currentSrc;

            document.body.appendChild(image);
        }
    }
}
